import { jwtDecode } from 'jwt-decode';

import { OpsUserDetails } from 'codegen';
import { TUser } from 'types';

interface IUEPUser {
  given_name: string;
  family_name: string;
  'https://adminportal.airmiles.ca/roles': string[];
}

export const getUserFromToken = (token = ''): TUser | null => {
  try {
    const user = jwtDecode<TUser & IUEPUser>(token);

    const roles = user['https://adminportal.airmiles.ca/roles'];

    if (user && roles) {
      const admin = roles.includes('unifiedXP-SNAP-Portal-Administrator') ? OpsUserDetails.role.ADMIN : undefined;
      const operator = roles.includes('unifiedXP-SNAP-Portal-Operator') ? OpsUserDetails.role.OPERATOR : undefined;

      const role = (admin || operator) ? { role: admin || operator } : null;

      return {
        ...user,
        ...role,
        name: `${user.given_name} ${user.family_name}`,
      };
    }

    return null;
  } catch (error) {
    console.error('Error decoding token:', error);

    return null;
  }
};

export const getUserStatus = (user?: TUser | null) => {
  const date = new Date().getTime();
  const currentTime = date / 1000;
  const isSessionExpired = (user && (user.exp < currentTime)) || !user?.role;

  return !!isSessionExpired;
};

export const isUserAdmin = (userRole?: OpsUserDetails.role) => userRole === OpsUserDetails.role.ADMIN;
